import { FC } from "react";
import {
  ContactInfoWrapper,
  DocumentsBlock,
  InfoForm,
  InfoText,
  Phone,
  Payed,
} from "./styles";

const info: {
  id: number;
  phone: string;
  birth: string;
  experience: string;
  pay: string;
}[] = [
  {
    id: 1,
    phone: "+7 999 999 99 99",
    birth: "др: 16.12.1990 (32 лет)",
    experience: "Стаж вождения: 5 лет",
    pay: "Депозит/карта",
  },
];

export const Info: FC = () => (
  <ContactInfoWrapper>
    {info.map(({ id, phone, birth, experience, pay }) => (
      <InfoForm key={id}>
        <Phone>{phone}</Phone>
        <InfoText>{birth}</InfoText>
        <InfoText>{experience}</InfoText>
        <DocumentsBlock>
          <InfoText>Оплачена бронь</InfoText>
          <Payed>{pay}</Payed>
        </DocumentsBlock>
      </InfoForm>
    ))}
  </ContactInfoWrapper>
);
